<div class="table-responsive-wrapper" *ngIf="areLoaded">
    <table mat-table id="myTable" class="subjects__table" #myTable [dataSource]="page.content">
        <ng-container matColumnDef="csrName">
            <th mat-header-cell *matHeaderCellDef>
                {{ 'GLOBAL.CENTER' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element?.csrName }}
            </td>
        </ng-container>
        <ng-container matColumnDef="registrationId">
            <th mat-header-cell *matHeaderCellDef>
                {{ 'SUBJECTS.REGID' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element?.registrationId }}
            </td>
        </ng-container>
        <ng-container matColumnDef="lastName">
            <th mat-header-cell *matHeaderCellDef>
                {{ 'SUBJECTS.LASTNAME' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">{{ element?.lastName }}</td>
        </ng-container>
        <ng-container matColumnDef="firstName">
            <th mat-header-cell *matHeaderCellDef>
                {{ 'SUBJECTS.FIRSTNAME' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">{{ element?.firstName }}</td>
        </ng-container>
        <ng-container matColumnDef="parentName">
            <th mat-header-cell *matHeaderCellDef>
                {{ 'SUBJECTS.PARENTNAME' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">{{ element?.parentName }}</td>
        </ng-container>
        <ng-container matColumnDef="dateOfBirth">
            <th mat-header-cell *matHeaderCellDef>
                {{ 'SUBJECTS.DATEOFBIRTH' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
                {{ element?.dateOfBirth | date:"dd.MM.yyyy."}}
            </td>
        </ng-container>
        <ng-container matColumnDef="jmbg">
            <th mat-header-cell *matHeaderCellDef>
                {{ 'SUBJECTS.JMBG' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">{{ element?.jmbg }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>
                {{ 'SUBJECTS.STATUS' | translate }}
            </th>
            <td mat-cell *matCellDef="let element"><status-label status="{{element?.cpsuStatus=='ACTIVE'?1:2}}">
                    {{ element?.cpsuStatus!==''?('GLOBAL.SUBJECT.CPSU_STATUS_'+element?.cpsuStatus | translate):'' }}
                </status-label></td>
        </ng-container>
        <ng-container matColumnDef="actions" *ngIf="isUserManager">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" class="table__cell table__cell--align-right">
                <button mat-icon-button class="button-square table__row-button" color="primary"
                    matTooltip="{{ 'SUBJECTS.MORE_TOOLTIP' | translate }}" [matMenuTriggerFor]="menu"
                    #menuTrigger="matMenuTrigger" (click)="$event.stopPropagation()">
                    <mat-icon class="button-square__icon">more_horiz</mat-icon>
                </button>
                <mat-menu #menu="matMenu" class="filter-menu">
                    <button mat-menu-item (click)="handleOpenDialog(element)"
                        [disabled]="element.registrationId === null">
                        <mat-icon>person_add</mat-icon>
                        {{ 'SUBJECTS.ASSIGNE_DOSSIER' | translate }}
                    </button>
                </mat-menu>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="subjects__row--header"></tr>
        <tr mat-row *matRowDef="let element; let row; columns: displayedColumns" (click)="onRowClicked(element)"
            class="subjects__row">
        </tr>
    </table>
</div>